'use strict';

(function () {
  'use strict';

  angular.module('msPublicActivities').controller('PublicActivityCompleteCtrl', PublicActivityCompleteCtrl);

  PublicActivityCompleteCtrl.$inject = ['$log', '$stateParams', 'activity', 'providerSvc', 'NotifyingSvc', 'msAuth'];

  /* @ngInject */
  function PublicActivityCompleteCtrl($log, $stateParams, activity, providerSvc, NotifyingSvc, msAuth) {
    var vm = this;
    vm.$onInit = activate;
    vm.title = 'PublicActivityCompleteCtrl';
    vm.signupFormVisible = false;
    vm.isUser = false; //if this is an existing user, valid token would have been included in querystring
    var fallbackIntroKey = 'publicActivities.noOrgFallbackIntro';
    var providerIntroKey = 'publicActivities.partnerIntro';
    var providerIntroKeyForUser = 'publicActivities.partnerIntroAlt';
    vm.introKey = fallbackIntroKey;

    ////////////////

    function activate() {
      $log.debug('PublicActivityCompleteCtrl ctrl activate');
      vm.activity = activity;
      if ($stateParams.o) {
        _renderProviderText();
      }
      if (msAuth.isWriteOnlyUser()) {
        vm.isUser = true;
      }
    }

    function _renderProviderText() {
      providerSvc.getHeaderImage().then(function (headerContent) {
        if (headerContent) {
          vm.providerLogo = headerContent;
          // TODO: This is the Org's shortName. We need a public endpoint for basic provider info to use as a better alt-text.
          vm.providerName = $stateParams.o;
          vm.introKey = vm.isUser ? providerIntroKeyForUser : providerIntroKey;
        }
      });
    }

    NotifyingSvc.notifyEvent(NotifyingSvc.EVENTS.PAGE_TITLE, {
      pageTitle: activity.title
    });
  }
})();